import { Datagrid, SimpleList, TextField } from 'react-admin';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';

export const RoleList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return (
        <InfiniteList>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.code}
                    secondaryText={record => record.name}
                />
            ) : (
                <Datagrid>
                    <TextField source="code" />
                    <TextField source="name" />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
